import { onSnapshot, applySnapshot, getSnapshot } from "mobx-state-tree";

export const persist = (name, store, options = {}) => {
  // `exclude`: top-level keys that are never written to storage (e.g. large,
  // refetchable data that would blow the storage quota).
  let { storage, jsonify, shouldPersist, exclude = [] } = options;

  onSnapshot(store, (_snapshot) => {
    if (typeof shouldPersist === "function" && !shouldPersist(_snapshot)) {
      return;
    }
    const snapshot = { ..._snapshot };
    exclude.forEach((key) => delete snapshot[key]);
    const data = !jsonify ? snapshot : JSON.stringify(snapshot);
    try {
      storage.setItem(name, data);
    } catch (error) {
      // Name the heaviest fields — a quota error is otherwise impossible to
      // act on without knowing what filled the store.
      const sizeInKb = (value) =>
        Math.round((JSON.stringify(value)?.length || 0) / 1024);
      const largestFields = Object.entries(snapshot)
        .map(([key, value]) => `${key}: ${sizeInKb(value)}KB`)
        .sort(
          (a, b) => parseInt(b.split(": ")[1], 10) - parseInt(a.split(": ")[1], 10)
        )
        .slice(0, 5)
        .join(", ");
      console.error(
        `Failed to persist "${name}" to storage (total ${sizeInKb(
          snapshot
        )}KB; largest: ${largestFields})`,
        error
      );
    }
  });

  const data = storage.getItem(name);

  if (data) {
    const snapshot = !jsonify ? data : JSON.parse(data);
    // Keep the store's own values for excluded keys, so a missing key (or a
    // stale one left by an older snapshot) doesn't overwrite them.
    const current = getSnapshot(store);
    exclude.forEach((key) => {
      snapshot[key] = current[key];
    });
    applySnapshot(store, snapshot);
  }

  return data;
};
